import {
  AiOutlineCalendar,
  AiOutlineClockCircle,
  AiOutlineExclamation,
  AiOutlineNotification,
  AiOutlineTeam,
  AiOutlineTrophy,
} from 'react-icons/ai';
import { IconType } from 'react-icons/lib';

export const NotificationIcon: any = {
  'fa fa-calendar': AiOutlineCalendar,
  'fa fa-users': AiOutlineTeam,
  'fa fa-trophy': AiOutlineTrophy,
  'fa fa-clock': AiOutlineClockCircle,
  'fa fa-exclamation': AiOutlineExclamation,
};

export const getNotificationIcon = (type?: string): IconType => {
  let ReturnIcon = AiOutlineNotification;
  if (type) {
    ReturnIcon = NotificationIcon[type] ?? ReturnIcon;
  }

  return ReturnIcon;
};
